<template>
  <div v-if="wishlistData && wishlistData.items.length > 0">
    <!-- Slot to render title or something -->
    <slot></slot>

    <div class="bg-white lg:p-4">
      <div
        class="grid gap-4 grid-cols-1 sm:grid-cols-2"
        :class="[emptyCartMode ? 'lg:grid-cols-3 xl:grid-cols-4' : 'xl:grid-cols-3']"
      >
        <template v-for="item in wishlistData.items" :key="`${item.sku}-${item.id}`">
          <WishlistProduct :item="item" />
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const wishlist = useWishlist()

const { emptyCartMode = false } = defineProps<{
  emptyCartMode?: boolean
}>()

onMounted(async () => {
  await wishlist.init()
})

const wishlistData = computed(() => {
  return wishlist.data.value
})
</script>
